import Layout from 'antd/lib/layout';
import Typography from 'antd/lib/typography';
import React, { useState } from 'react';
import { ICreateSavedFilter } from '../../../components/sidebar-filters/saved-filter/interface';
import { SidebarFiltersGroupCollapse } from '../../../components/sidebar-filters/SidebarFiltersGroupCollapse';
import { SidebarWrapper } from '../../../components/sidebar-filters/SidebarWrapper';
import { ICloudVenSidebarFilters, useCloudVenSidebarFiltersContext } from './CloudVenSidebarFiltersContext';
import { CloudVenSidebarTabs } from './CloudVenSidebarTabs';
import { CLOUD_VEN_PAGE_CONST } from './constants';
import { SaveCloudVenFiltersModal } from './SaveCloudVenFiltersModal';

interface ICloudVenSidebarProps {
    collapsed: boolean;
    onCollapseChange: (value: boolean) => void;
    totalRecords?: number;
    onFilterChange: (filter: ICloudVenSidebarFilters) => void;
    gridComponent: React.ReactNode;
}

export const CloudVenSidebar: React.FC<ICloudVenSidebarProps> = ({ collapsed, onCollapseChange, totalRecords, onFilterChange, gridComponent }) => {
    const {
        selectedSavedFilter,
        handleSavedFilterSelect,
        handleCreateSavedFilter,
        isCreateFilterLoading,
        handleUpdateSavedFilter,
        isUpdateFilterLoading,
    } = useCloudVenSidebarFiltersContext();

    const [saveFiltersModalOpen, setSaveFiltersModalOpen] = useState(false);

    const handleOpenSaveFiltersModal = (savedFilterData: ICreateSavedFilter | null) => {
        setSaveFiltersModalOpen(true);
        handleSavedFilterSelect(savedFilterData);
    };

    const handleCancelSaveFilters = () => {
        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    const handleSaveFilters = async (filterData: ICreateSavedFilter) => {
        const upsertSavedFilter = filterData.id ? handleUpdateSavedFilter : handleCreateSavedFilter;

        await upsertSavedFilter(filterData);

        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    return (
        <>
            <SidebarWrapper
                collapsed={collapsed}
                onCollapseChange={onCollapseChange}
                collapsedWidth={CLOUD_VEN_PAGE_CONST.collapsedWidth}
                expandedWidth={CLOUD_VEN_PAGE_CONST.expandedWidth}
            >
                <Layout.Content
                    style={{
                        padding: 0,
                        margin: 0,
                        height: '100%',
                    }}
                >
                    {!collapsed && (
                        <div style={{ padding: '14px 12px 8px' }}>
                            <Typography.Text>Total Records: {totalRecords}</Typography.Text>
                        </div>
                    )}
                    <SidebarFiltersGroupCollapse collapsed={collapsed} setCollapsed={onCollapseChange} selectedItemsCount={0} />

                    {!collapsed && (
                        <CloudVenSidebarTabs
                            onFilterChange={onFilterChange}
                            onOpenSaveFiltersModal={handleOpenSaveFiltersModal}
                            gridComponent={gridComponent}
                        />
                    )}
                </Layout.Content>
            </SidebarWrapper>

            {/* Modals goes here === */}
            {saveFiltersModalOpen && selectedSavedFilter && (
                <SaveCloudVenFiltersModal
                    isLoading={isCreateFilterLoading || isUpdateFilterLoading}
                    initialSavedFilter={selectedSavedFilter}
                    onCancel={handleCancelSaveFilters}
                    onSave={handleSaveFilters}
                />
            )}
        </>
    );
};
